import React, {useEffect, useRef} from "react"
import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import Banner from "../../../components/banner"

const Contenido = (props) => {
    const isMountedComponent = useRef(true)
    useEffect(() => {
        if (isMountedComponent.current) {
            window.jquery_scripts()
        }
        return () => {
            isMountedComponent.current = false
        }
    })
    return (
        <Layout location={props.location}>
            <SEO title="IRStrat III"/>
            <Banner title="IRStrat III"/>
            <section className="service_details_area aspectos servicios">
                <div className="container">
                    <div className="section_title black_c">
                        <p className="f_16">Se enfoca en conocer a profundidad y expandir ágilmente su base de
                            inversionistas y
                            coberturas, a través de una sólido lobbying institucional y un amplio portafolio de
                            productos de análisis,
                            en pro de una mayor consecución de recursos y una óptima visibilidad y bursatilidad. Este paquete incluye lo siguiente:</p>
                    </div>
                    <div className="row">
                       <div className="col-lg-12">
                             <div className="service_left_sidebar_old">
                                <ul className="nav nav-tabs service_tab mb_50" id="myTab" role="tablist">
                                    <li className="nav-item">
                                        <a className="nav-link active show" id="paquete1-tab" data-toggle="tab"
                                           href="#paquete1" role="tab"
                                           aria-controls="paquete1" aria-selected="true">Bloque 1</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" id="paquete2-tab" data-toggle="tab" href="#paquete2"
                                           role="tab"
                                           aria-controls="paquete2" aria-selected="false">Bloque 2</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" id="paquete3-tab" data-toggle="tab" href="#paquete3"
                                           role="tab"
                                           aria-controls="paquete3" aria-selected="false">Bloque 3</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-lg-12">
                            <div className="tab-content" id="myTabContent">
                                <div className="tab-pane fade active show" id="paquete1" role="tabpanel"
                                     aria-labelledby="paquete1-tab">
                                    <div className="service_right_sidebar p-0 mb-5">
                                        <div className="service_content">
                                            <div id="accordion" role="tablist" aria-multiselectable="true"
                                                 className="panel-group faq-accordion service_accordion">
                                                 <div className="row">
                                                    <div className="col-md-6 mb-5">
                                                        <div className="" role="tab">
                                                            <h4 className="panel-title">
                                                            Identificación de
                                                                    inversionistas

                                                            </h4>
                                                        </div>

                                                            <div className="panel-body">


                                                                <ul className="list_style">
                                                                    <li><i className="fa fa-angle-right"></i>Ejecución de
                                                                        estudios de percepción
                                                                    </li>
                                                                    <li><i className="fa fa-angle-right"></i>Estructuración
                                                                        de proxies de tenencia accionaria
                                                                    </li>
                                                                    <li><i className="fa fa-angle-right"></i>Elaboración de
                                                                        expedientes informativos de perfiles
                                                                    </li>
                                                                    <li><i className="fa fa-angle-right"></i>Sondeos
                                                                        post-resultados
                                                                    </li>
                                                                </ul>
                                                            </div>

                                                    </div>
                                                    <div className="col-md-6 mb-5">
                                                    <div className="" role="tab">
                                                        <h4 className="panel-title">
                                                          Eventos propios

                                                        </h4>
                                                    </div>

                                                        <div className="panel-body">

                                                            <ul className="list_style">
                                                                <li><i className="fa fa-angle-right"></i>Planeación y
                                                                    logística para investor day
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Planeación y
                                                                    logística para visitas en sitio
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Planeación y
                                                                    logística de ruedas de prensa
                                                                </li>
                                                            </ul>
                                                        </div>

                                                </div>

                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="" role="tab">
                                                            <h4 className="panel-title">
                                                            Prospección de inversionistas

                                                            </h4>
                                                        </div>

                                                            <div className="panel-body">

                                                                <ul className="list_style">
                                                                    <li><i className="fa fa-angle-right"></i>Targeting de
                                                                        inversionistas buy-side
                                                                    </li>
                                                                    <li><i className="fa fa-angle-right"></i>Definición de
                                                                        segmento objetivo (estilo de inversión, perfil,
                                                                        etc.)
                                                                    </li>
                                                                    <li><i className="fa fa-angle-right"></i>Asesoría en
                                                                        Road Shows y Non-Deal Road Shows
                                                                    </li>
                                                                    <li><i className="fa fa-angle-right"></i>Presentaciones
                                                                        con las áreas de promoción bursátil
                                                                    </li>
                                                                    <li><i className="fa fa-angle-right"></i>Alimentación y
                                                                        aumento de listas de distribución
                                                                    </li>
                                                                    <li><i className="fa fa-angle-right"></i>Presentaciones
                                                                        y eventos con fondos de pensiones e inversión
                                                                    </li>
                                                                </ul>
                                                            </div>

                                                    </div>

                                                    <div className="col-md-6">
                                                    <div  role="tab">
                                                        <h4 className="panel-title">
                                                          Cobertura de análisis

                                                        </h4>
                                                    </div>

                                                        <div className="panel-body">

                                                            <ul className="list_style">
                                                                <li><i className="fa fa-angle-right"></i>Desarrollo de
                                                                    modelos de valuación
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Definición de
                                                                    segmento objetivo (estilo de inversión, perfil,
                                                                    etc.)
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Targeting de
                                                                    inversionistas sell-side
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Presentaciones
                                                                    con las áreas de análisis
                                                                </li>
                                                            </ul>
                                                        </div>

                                                </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="paquete2" role="tabpanel"
                                     aria-labelledby="paquete2-tab">
                                    <div className="service_right_sidebar p-0 mb-5">
                                        <div className="service_content">
                                            <div id="p2_accordion" role="tablist" aria-multiselectable="true"
                                                 className="panel-group ">
                                                <div className="row">
                                                    <div className="col-md-6 mb-5">
                                                    <div className="" role="tab">
                                                        <h4 className="panel-title">
                                                            Estrategia de Medios

                                                        </h4>
                                                    </div>
                                                        <div className="card-block panel-body">


                                                            <ul className="list_style">
                                                                <li><i className="fa fa-angle-right"></i>Consecución de
                                                                    espacios con medios financieros especializados en
                                                                    México y Estados Unidos (escritos, radio y TV)
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Planeación y
                                                                    ejecución de ruedas de prensa
                                                                </li>
                                                            </ul>
                                                    </div>
                                                </div>
                                                    <div className="col-md-6 mb-5">
                                                    <div className="" role="tab">
                                                        <h4 className="panel-title">
                                                            Monitoreo de medios

                                                        </h4>
                                                    </div>
                                                        <div className="panel-body">

                                                            <ul className="list_style">
                                                                <li><i className="fa fa-angle-right"></i>Inteligencia en
                                                                    reportes de analistas
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Inteligencia en
                                                                    redes sociales (Twitter y Linkedin)
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Inteligencia en
                                                                    blogs especializados
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Inteligencia en
                                                                    medios
                                                                </li>
                                                            </ul>
                                                        </div>

                                                </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 mb-5">
                                                    <div className="" role="tab">
                                                        <h4 className="panel-title">
                                                            Benchmarking
                                                        </h4>
                                                    </div>

                                                        <div className="panel-body">

                                                            <ul className="list_style">
                                                                <li><i className="fa fa-angle-right"></i>Comparativos de
                                                                    resultados anuales (sector, mercado y región)
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Comparativos de
                                                                    resultados trimestrales (sector, mercado y región)
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Comparativos de
                                                                    “opinión” (posicionamiento y visibilidad)
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Comparativos de
                                                                    Programa de RI
                                                                </li>
                                                            </ul>
                                                        </div>

                                                </div>
                                                    <div className="col-md-6 mb-5">
                                                    <div className="" role="tab">
                                                        <h4 className="panel-title">
                                                           Marco regulatorio
                                                        </h4>
                                                    </div>

                                                        <div className="panel-body">

                                                            <ul className="list_style">
                                                                <li><i className="fa fa-angle-right"></i>Información
                                                                    puntual de cambios en la regulación (CNBV, CONSAR,
                                                                    BMV, BIVA y SEC)
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Asesoría de
                                                                    implementación (XBRL, insider trading, entre otras)
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Estructuración
                                                                    de funciones corporativas
                                                                </li>
                                                            </ul>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="paquete3" role="tabpanel"
                                     aria-labelledby="paquete3-tab">
                                    <div className="service_right_sidebar p-0 mb-5">
                                        <div className="service_content">
                                            <div id="p3_accordion" role="tablist" aria-multiselectable="true"
                                                 className="panel-group faq-accordion service_accordion">
                                                 <div className="row">
                                                <div className="col-md-4">
                                                    <div className="" role="tab">
                                                        <h4 className="panel-title">
                                                            Asesoría en trading

                                                        </h4>
                                                    </div>
                                                        <div className="card-block panel-body">


                                                            <ul className="list_style">
                                                                <li><i className="fa fa-angle-right"></i>Asesoría en
                                                                    operaciones de tesorería (recompras, fondos
                                                                    “espejo”, etc.)
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Asesoría en
                                                                    operación de formadores de mercado
                                                                </li>
                                                            </ul>

                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="" role="tab">
                                                        <h4 className="panel-title">
                                                            Agenda estratégica

                                                        </h4>
                                                    </div>
                                                        <div className="panel-body">

                                                            <ul className="list_style">
                                                                <li><i className="fa fa-angle-right"></i>Eventos
                                                                    financieros nacionales e internacionales (cumbres,
                                                                    mesas redondas, foros, etc.)
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Lobbying pro
                                                                    participación (buscamos su visibilidad)
                                                                </li>
                                                            </ul>
                                                        </div>

                                                </div>
                                                <div className="col-md-4">
                                                    <div className="" role="tab">
                                                        <h4 className="panel-title">
                                                            Servicios IR Edge 3.0
                                                        </h4>
                                                    </div>
                                                        <div className="panel-body">

                                                            <ul className="list_style">
                                                                <li><i className="fa fa-angle-right"></i>Terminal IREdge
                                                                </li>
                                                                <li><i className="fa fa-angle-right"></i>Interfase de
                                                                    inteligencia
                                                                </li>
                                                            </ul>

                                                    </div>
                                                </div>
</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </Layout>
    )
}

export default Contenido
